const RELAXED_PRIVACY_ENVS = ['local', 'develop', 'staging'];

export type DatadogConfig = {
  applicationId: string;
  clientToken: string;
  site: string;
  service: string;
  env: string;
  version: string;
  /**
   * true: Session Replay を高サンプリング・非マスクで動かしてよい環境。
   * false: それ以外(本番を含む未知の値・タイポ含む)。安全側に倒し必ずマスクする。
   */
  isRelaxedPrivacyEnv: boolean;
};

/**
 * 環境変数から Datadog の設定を組み立てる。有効でない場合は undefined を返す。
 *
 * NEXT_PUBLIC_ の値は next build 時に文字列としてバンドルへ埋め込まれる。
 * 埋め込みは process.env.XXX というリテラル参照にだけ効くので、
 * 分割代入や動的キーでの参照に書き換えないこと(undefined になる)。
 */
export const resolveDatadogConfig = (): DatadogConfig | undefined => {
  if (process.env.NEXT_PUBLIC_DATADOG_ENABLED?.trim().toLowerCase() !== 'true') {
    return undefined;
  }

  const applicationId = process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID?.trim();
  const clientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN?.trim();
  const site = process.env.NEXT_PUBLIC_DATADOG_SITE?.trim();
  const service = process.env.NEXT_PUBLIC_DATADOG_SERVICE?.trim();
  const env = process.env.NEXT_PUBLIC_DATADOG_ENV?.trim().toLowerCase();

  if (!applicationId || !clientToken || !site || !service || !env) {
    return undefined;
  }

  return {
    applicationId,
    clientToken,
    site,
    service,
    env,
    version: process.env.NEXT_PUBLIC_APP_VERSION?.trim() || 'local',
    isRelaxedPrivacyEnv: RELAXED_PRIVACY_ENVS.includes(env),
  };
};
